import { RouteLocationNormalized, NavigationGuardNext } from 'vue-router';
import { useKnowledgeStore } from '@getmayday/vue-modules';

export default async (
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  next: NavigationGuardNext,
) => {
  const { modalContentId, silent, source, lang } = to.query;
  const fromModalContentId = from.query.modalContentId;
  const fromLang = from.params.lang;
  const toLang = to.params.lang;
  const knowledgeStore = useKnowledgeStore();

  if (modalContentId && modalContentId !== '-1' && !silent) {
    const splitId = (modalContentId as string).split('#');
    const contentId = splitId[0];
    const modalHash = splitId[1] || '';
    const hash = modalHash ? `#${modalHash}` : '';
    const isModal = true;

    // Guard clause to prevent displaying modal when opening it for an answer
    if (!modalContentId) {
      return next();
    }

    if (fromModalContentId === modalContentId && !lang && fromLang === toLang) {
      if (hash) knowledgeStore.setContentHash({ hash, isModal });
      return next();
    }

    const { modalContent, content } = storeToRefs(knowledgeStore);
    if (
      modalContent.value.id === modalContentId &&
      !lang &&
      fromLang === toLang
    ) {
      return next();
    }

    await knowledgeStore.getEntityAncestors({
      id: contentId,
      entityType: 'Content',
      lang: (lang || toLang) as string,
      isModal,
      hash,
      source: source as string,
      shouldLog: content.value.id !== modalContentId,
    });
  }
  next();
};
